export default __webpack_public_path__ + "static/media/energy.a50355f1.png";